import type { TestShackReportInspection } from "@/pages/products/test-shack/models/TestShackReport";
import { TestShackReportSectionRevList as SharedSectionRevList } from "@/pages/products/test-shack/shared/components/report/TestShackReportSectionRevList";
import type { TestShackReportSectionRev } from "../models/TestShackReportSectionRev";
import { formatMeasurement } from "@/pages/products/test-shack/utils/reportFormat";
import { testShackReportExcelParams } from "@/pages/products/test-shack/utils/reportExcelExport";
import { formatDeltaCode } from "../utils/format";
import type { ImageKind } from "./TestShackReportImageDialog";
import { TestShackReportSectionRevCard } from "./TestShackReportSectionRevCard";

interface TestShackReportSectionRevListProps {
	sectionRevs: TestShackReportSectionRev[];
	inspections: TestShackReportInspection[];
	isLoading: boolean;
	problemsOnly: boolean;
	showMinTargetMax: boolean;
	onProblemsOnlyChange: (problemsOnly: boolean) => void;
	onShowMinTargetMaxChange: (showMinTargetMax: boolean) => void;
	onViewImages: (
		inspection: TestShackReportInspection,
		kind: ImageKind,
	) => void;
	onError: (error: Error) => void;
}

export const TestShackReportSectionRevList = ({
	sectionRevs,
	inspections,
	onViewImages,
	...props
}: TestShackReportSectionRevListProps) => (
	<SharedSectionRevList
		{...props}
		sectionRevs={sectionRevs}
		inspectionCount={inspections.length}
		getExportParams={() =>
			testShackReportExcelParams(sectionRevs, props.showMinTargetMax, {
				header: (column) => formatDeltaCode(column.code),
				spec: (value) => formatMeasurement(value),
				reading: (cell) => formatMeasurement(cell?.value ?? null),
			})
		}
		renderSectionRev={({ sectionRev, isCollapsed, onToggle }) => (
			<TestShackReportSectionRevCard
				sectionRev={sectionRev}
				isCollapsed={isCollapsed}
				showMinTargetMax={props.showMinTargetMax}
				onToggle={onToggle}
				onError={props.onError}
				onViewImages={onViewImages}
			/>
		)}
	/>
);
